/** ----------------------------------------
     Helpers
 ---------------------------------------- */

import helper from './Helper';
import slide from './Templates';
import animation from './Animation';

/** ----------------------------------------
    Narrow Casting Posters
 ---------------------------------------- */

export class Posters {

    constructor() {
        this.active = '';
        this.refresh = {
            'data': 8000,
            'slider': 15000
        };
        this.screen = {};
        this.type = '';
        this.initialized = false;
        this.currentSlide = 0;
        this.introDuration = 2500;
        this.timerId = null;
        // this.init();
    }

    /** ----------------------------------------
         Get Interval
     ---------------------------------------- */

    // get interval() {
    //     return this.refresh['data'];
    // }

    /** ----------------------------------------
        Set Data
     ---------------------------------------- */

    set data(data) {
        this.screen = data;
        if (!this.initialized) {
            this.init();
        }
    }

    /** ----------------------------------------
         Handle Data
     ---------------------------------------- */

    _handle() {
        this._routine();
    }
    
    _delegate(data) {
        if (data) {
            const slides = {
                'info': () => this._poster(data),
            };
            return slides[data.type]();
        } else {
            this.currentSlide = 0;
            this._routine();
        }
    }

    _routine() {
        clearTimeout(this.timerId);
        const $this = this;

        this._createSlide();

        this.timerId = setTimeout( function() {
            $this._routine();
        }, this.refresh['slider']);
    }

    _transition() {
        // const transition = {
        //     'await': () => this._awaitOut(),
        //     'upcoming': () => this._upcomingOut(),
        //     'progress': () => this._progressOut()
        // };
        //
        // return transition[type]();
    }

    /** ----------------------------------------
         Set Slide
     ---------------------------------------- */

    _createSlide() {
        const index = this.currentSlide;
        const data = this.screen.feed[index];

        if (this.screen.feed.length === 0) {
            return;
        }

        this._delegate(data);
        this.currentSlide++;

        if (!this.screen.feed[index]) {
            this.currentSlide = 0;
        }
        if (this.currentSlide >= this.screen.feed.length) {
            this.currentSlide = 0;
        }
    }

    _copySlide() {
        helper.copy('container', 'active');
    }

    _deleteSlide() {
        helper.empty('retainer');
    }

    /** ----------------------------------------
        Set Poster
     ---------------------------------------- */

    _poster(data) {

        // if image doesn't load on time
        let loaded = false;
        let $this = this;
        setTimeout(function() {
            if (loaded == false) {
                $this._routine()
                console.log(`%c Image didn't load. Skipping slide `, 'background-color: rgb(255,0,0); color: white;');
            }
        }, 1500)
       
        data.image && helper.imageLoaded(data.image).then(() => {
            loaded = true
            helper.empty();
            helper.insert(slide.poster(data));

            const slideEl = document.body.querySelector('.screen__slide');
            animation.fadeIn(slideEl);
            console.log(`%c showing slide ${this.currentSlide}/${this.screen.feed.length} `, 'background-color: rgb(255,0,0); color: white;');

            let $this = this;
            helper.schedule(this.refresh['slider'] - 1000, function() {
                animation.fadeOutDown(slideEl, 1000);
            })
        });
    }

    /** ----------------------------------------
        Set Video
     ---------------------------------------- */

    _video(data) {
        let $this = this;

        const skipVideo = () => {
            let $this = this;
            helper.schedule(100,function(){
                $this._routine();
            })
        }

        if (!navigator.onLine) {
            console.log(`%c no internet. skip video `, 'background-color: #7a00c6; color: white;');
            skipVideo();
        } else {

            if (data.video) {
                helper.empty();
                helper.insert(slide.video())
                const video = slide.setVideo(data);
                let $this = this;
                video.load(data.video);
                video.play();

                video.on('error', (err) => {
                    console.log('VIDEO ERROR')
                    skipVideo();
                })
                video.on('unplayable', (videoId) => {
                    console.log('VIDEO UNPLAYABLE')
                    skipVideo();
                })

                video.on('playing', () => {

                    // if video keeps buffering for too long
                    video.on('buffering', (videoId) => {
                        helper.schedule(8000, function() {
                            let state = video.getState();
                            if (state !== 'playing') {
                                $this._routine();
                            }
                        })
                    })

                    let duration = video.getDuration() * 1000;
                    
                    console.log(`%c playing video. duration: ${duration} `, 'background-color: #7a00c6; color: white;');
                    clearTimeout(this.timerId);

                    const el = document.body.querySelector('.screen-video');
                    animation.fadeIn(el);

                    helper.schedule(duration - 1000, function() {
                        console.log(`%c fading out video `, 'background-color: #7a00c6; color: white;');
                        animation.fadeOut(el, 1000);
                    })

                    video.on('ended', () => {
                        console.log(`%c video ended `, 'background-color: #7a00c6; color: white;');
                        $this._routine();
                    })
                })
            } else {
                console.log(`%c no video data `, 'background-color: #7a00c6; color: white;');
                skipVideo();
            }

        }
    }

    /** ----------------------------------------
        Intro
     ---------------------------------------- */

    _intro() {
        let $this = this;
        const introEl = document.body.querySelector('.screen-intro');
        const logoEl = document.body.querySelector('.screen-intro__logo svg');
        animation.zoomIn(logoEl, $this.introDuration * 2 , 0, 1.1)
        animation.fadeOut(introEl, 1000, $this.introDuration);
        helper.initFadeIn();
        helper.schedule($this.introDuration, function() {
            // INITIALIZA CYCLE
            $this._handle();
        })
    }

    /** ----------------------------------------
        Initialize
     ---------------------------------------- */

    init() {
        this._intro();
        this.initialized = true;

        // refresh after 1 hr (only if connected)
        helper.schedule(3600000, function() {
            if (navigator.onLine) {
                location.reload();
            }
        })
    }
}